// extracted by mini-css-extract-plugin
export default {"box":"Forecast_box__qTCVc"};